import { ReduxRootState } from 'types'

export const selectAuthIsAuthenticated = (state: ReduxRootState) =>
  state.oauth.isAuthenticated

export const selectAuth = (state: ReduxRootState) => state.oauth
